<template>
  <div v-if="isVisible" class="dsgvo-banner" role="dialog" aria-label="Datenschutzhinweis">
    <div class="dsgvo-inner">
      <p class="dsgvo-text">
        Laubloch ist ein privates, nicht-kommerzielles Kunstprojekt im Rahmen eines Universitätsstudiums.
        Beim bloßen Besuch werden technische Zugriffsdaten (u.&thinsp;a. IP-Adresse) kurzfristig auf dem Server gespeichert.
        Wer einen Account erstellt, willigt zusätzlich in die Speicherung der E-Mail-Adresse,
        des generierten Schlüsselloches und der Bewertungen ein (Rechtsgrundlage: Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;a DSGVO).
        Für eingeloggte Nutzer wird ein technisch notwendiges Sitzungs-Cookie gesetzt (30&nbsp;Tage, §&nbsp;25 Abs.&nbsp;2 Nr.&nbsp;2 TDDDG).
        Kein Tracking, keine Weitergabe an Dritte.
        <router-link to="/datenschutz" class="dsgvo-link">Datenschutzerklärung</router-link>
      </p>
      <div class="dsgvo-buttons">
        <button class="dsgvo-button" @click="accept">Verstanden</button>
        <button class="dsgvo-button" @click="reject">Ablehnen</button>
      </div>
    </div>
  </div>
</template>

<script>
import { consentStatus, giveConsent, rejectConsent } from '../services/consent.js'

export default {
  name: 'DSGVOBanner',
  computed: {
    isVisible() {
      return consentStatus.value === null
    }
  },
  methods: {
    accept() {
      giveConsent()
    },
    reject() {
      rejectConsent()
    }
  }
}
</script>

<style scoped>
.dsgvo-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid black;
  z-index: 2000;
  padding: 1rem 1.25rem;
}

.dsgvo-inner {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  max-width: 900px;
  margin: 0 auto;
}

.dsgvo-text {
  font-family: 'Avenir Next', 'Avenir', sans-serif;
  font-size: 0.8125rem;
  font-weight: 200;
  line-height: 1.55;
  text-align: left;
  flex: 1;
  color: black;
}

.dsgvo-link {
  font-family: 'Avenir Next', 'Avenir', sans-serif;
  font-size: 0.8125rem;
  font-weight: 200;
  font-style: italic;
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.dsgvo-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-shrink: 0;
}

.dsgvo-button {
  font-family: 'Avenir Next', 'Avenir', sans-serif;
  font-size: 0.9375rem;
  font-weight: 200;
  background: #fff;
  border: 1px solid black;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
  text-align: center;
}

.dsgvo-button:hover {
  background: #f0f0f0;
}

@media (max-width: 600px) {
  .dsgvo-inner {
    flex-direction: column;
    align-items: stretch;
    gap: 0.875rem;
  }

  .dsgvo-buttons {
    flex-direction: row;
    flex-wrap: wrap;
    width: auto;
  }

  .dsgvo-button {
    width: auto;
    min-width: unset;
    padding: 0.5rem 1rem;
  }
}
</style>
